module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGaa8589e61455c39ae25842b490160b05.aa8589e6.png";